<template>
	<div :class="['by-form-item', { is_error: !isSuccess }]">
		<label :for="prop" v-if="label" :style="{ width: labelWidth }"
			:class="['form-item__label', { 'form-item__label--error': error }]">
			<!-- <svg-icon
        v-if="labelIcon"
        :name="labelIconName"
        :size="labelIconSize"
        :color="isSuccess ? '#0046B9' : '#d83f3f'"
      ></svg-icon> -->
			<slot name="label" v-if="label || $slots.label">{{ label }}</slot>
			<slot name="success-icon" v-if="success">
				<!-- <div class="success-icon">�/div> -->
				<img class="success-icon" src="@/assets/img/client/check/check-circle@2x.png" width="16px"
					height="16px" />
			</slot>
			<slot name="success-icon" v-if="error">
				<img class="success-icon" src="@/assets/img/client/check/ic_error.png" width="16px" height="16px" />
			</slot>
		</label>
		<slot ref="slot"></slot>
		<!-- <transition name="el-zoom-in-top">
      <div
        :key="errorMsg"
        class="error-box"
        v-if="errorMsg && !byForm.errorIsNoText"
      >
        {{ errorMsg }}
      </div>
    </transition> -->
	</div>
</template>

<script>
	//import SvgIcon from "../SvgIcon.vue";
	import validator from './validator';
	import { dataType } from '@/utils/util.js';
	// import Emitter from "@/src/util/emitter";
	export default {
		name: 'ByFormItem',
		componentName: 'ByFormItem',
		// mixins: [Emitter],
		components: {
			//SvgIcon,
		},
		props: {
			required: { type: Boolean, default: false },
			prop: { type: String, default: '' },
			label: { type: String, default: '' },
			labelWidth: { type: String, require: false, default: 'auto' },
			labelIcon: { type: Boolean, required: false, default: false },
			// success: { type: Boolean, required: false, default: false },
			labelIconName: { type: String, required: false, default: '' },
			labelIconSize: { type: Number, required: false, default: 16 }
		},
		inject: ['byForm'],
		data() {
			return {
				isSuccess: true,
				errorMsg: '',
				success: false,
				error: false,
			};
		},
		mounted() {
			// console.log("🚀 ~ this.byForm", this.byForm);
			// console.log(222222222)
			this.$on(`by.form.blur`, this.onField);
			this.$on(`by.form.change`, this.onField);
			this.$on('by.form.submit', this.onFieldSubmit);
		},
		methods: {
			valitate(val) {
				debugger;
				if (!this.prop) return;
				if (
					Object.prototype.toString.call(this.byForm.rules[this.prop]) ===
					'[object Object]'
				) {
					this.byForm.rules[this.prop] = [this.byForm.rules[this.prop]];
				}
				// debugger

				validator.add(val, this.byForm.rules[this.prop]);
				validator.start().then((error) => {
					// debugger;
					//
					// if (!error&&error !== "error") {
					//   this.errorMsg = error;
					//   this.isSuccess = false;
					// }
					if (error) {
						this.errorMsg = error
						this.isSuccess = false
					} else {
						this.isSuccess = true
						this.errorMsg = ''
					}
				});
			},
			onFieldBlur(val) {
				// debugger;
				// console.log(11111111, val);
				// if (this.byForm.submit) return;
				// this.valitate(val);

				this.valitate(this.byForm.model[this.prop] || '');
				// debugger
				// validator.add(val, this.byForm.rules[this.prop])
				// let error = await validator.start()
				// if (error) {
				//   this.errorMsg = error
				// } else {
				//   this.errorMsg = ""
				// }
				// console.log("🚀 ~ onFieldBlur")
				// console.log("🚀 ~ val", val)
				// if (this.validate === "error") {
				//   if (!val && this.byForm.ruleKeys.includes(this.prop)) {
				//     this.validate = "error";
				//     // this.$children[0].focus()
				//     // this.$refs['slot'].focus()
				//   } else {
				//     this.validate = "success";
				//   }
				// }
			},
			onFieldChange(val) {
				this.valitate(this.byForm.model[this.prop] || '');
			},
			onFieldSubmit(key) {
				// debugger
				// if (this.prop === key) {
				//   this.validate = "error";
				// }
				this.valitate(this.byForm.model[this.prop] || '');
			},
			onField(val) {
				// console.log(this.byForm.rules[this.prop]);
				debugger;
				if (
					this.byForm.rules[this.prop] &&
					this.byForm.rules[this.prop].trigger
				) {
					let trigger = this.byForm.rules[this.prop].trigger;
					if (dataType(trigger) === 'string') {
						if (['blur', 'change'].includes(trigger)) {
							this.valitate(this.byForm.model[this.prop] || '');
						}
					}
				}
			}
		}
	}
</script>
<style scoped lang="scss">
	.by-form-item+.by-form-item {
		display: flex;
	}

	.error-box {
		position: absolute;
		color: #d83f3f;
	}

	.form-item__label {
		// margin-bottom: 5px;
		display: block;
		margin-right: 18px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 12px;
		color: #333333;
		text-align: left;
		font-style: normal;
		line-height: 20px;
		text-align: left;
		height: 20px;
		display: flex;
		align-items: center;

		.success-icon {
			margin-left: 4px;
		}
	}

	.form-item__label.form-item__label--error {
		color: #d83f3f !important;
	}
</style>